/* eslint-disable */
// import VueRouter from '../../router/index'
// const { start_date } = VueRouter.currentRoute?.query
import Api from '@/repository/index'
// import globalMixin from '@/mixin/global'
// const { getUtcFromDate } = globalMixin.methods
const actions = {
  async updateScheduleTask ({ rootGetters, commit }, { date, scheduleId }) {
    try {
      commit('IncomeHistory/START_LOADING', 1, { root: true })
      console.log(rootGetters['IncomeHistory/getDataByScheduleID'](171798692632))
      const getDateByShehudleId = rootGetters['IncomeHistory/getDataByScheduleID'](String(scheduleId))
      console.log(getDateByShehudleId, date, scheduleId)
      if (getDateByShehudleId?.length === 0 && !date) return false
      const scheduleDate = getDateByShehudleId?.[0]?.schedule?.date
      await Api.worker.updateScheduleTask({ scheduleId, date: scheduleDate ?? date })
      commit('IncomeHistory/STOP_LOADING', 1, { root: true })
    } catch (error) {
      console.error(error)
      commit('IncomeHistory/STOP_LOADING', 1, { root: true })
    }
  }

}

export default {
  namespaced: true,
  actions
}
